import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import LoadingSpinner from '../../../components/common/LoadingSpinner';
import { getJobs } from '../../../services/jobsService';

const OperatorDashboard = () => {
  const [jobs, setJobs] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const load = async () => {
      try {
        const data = await getJobs();
        setJobs(data?.jobs || []);
      } finally {
        setLoading(false);
      }
    };
    load();
  }, []);

  if (loading) return <LoadingSpinner />;

  const toPrint = jobs.filter(j => j.status === 'approved');
  const ready = jobs.filter(j => j.status === 'printed' || j.status === 'ready_for_collection');

  return (
    <div className="space-y-6">
      <h2 className="text-2xl font-bold text-gray-900">Operator Dashboard</h2>
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
        <div className="card p-6">
          <h3 className="text-lg font-medium text-gray-900 mb-4">To Print (Approved)</h3>
          <ul className="list-disc pl-6 text-sm">
            {toPrint.map(j => (
              <li key={j._id} className="mb-1">
                {j.jobId} - {j.customer?.name} <Link to={`/jobs/${j._id}`} className="text-primary-600 ml-2">View</Link>
              </li>
            ))}
            {toPrint.length === 0 && <li className="text-gray-500">None</li>}
          </ul>
        </div>
        <div className="card p-6">
          <h3 className="text-lg font-medium text-gray-900 mb-4">Ready for Collection</h3>
          <ul className="list-disc pl-6 text-sm">
            {ready.map(j => (
              <li key={j._id} className="mb-1">
                {j.jobId} - {j.customer?.name} <Link to={`/jobs/${j._id}`} className="text-primary-600 ml-2">View</Link>
              </li>
            ))}
            {ready.length === 0 && <li className="text-gray-500">None</li>}
          </ul>
        </div>
      </div>
    </div>
  );
};

export default OperatorDashboard;
